import * as React from "react";
import { cn } from "@/lib/cn";

/** Date and time fields get a width that fits their text and open the browser's picker from a click anywhere on the field. */
const PICKER_WIDTH: Record<string, string> = { date: "min-w-[10.5rem]", "datetime-local": "min-w-[14rem]", time: "min-w-[7.5rem]", month: "min-w-[10rem]" };

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, onClick, ...props }, ref) => {
    const picker = type !== undefined && type in PICKER_WIDTH;
    return (
    <input
      ref={ref}
      type={type}
      onClick={(e) => {
        onClick?.(e);
        if (picker && !e.currentTarget.disabled && !e.currentTarget.readOnly) {
          try {
            e.currentTarget.showPicker();
          } catch {
            /* the browser has no picker, or refused it; typing still works */
          }
        }
      }}
      className={cn(
        "flex h-9 w-full rounded-md border-0 bg-white px-3 text-sm text-neutral-900 shadow-xs ring-1 ring-inset ring-neutral-200",
        "placeholder:text-neutral-400 transition-shadow duration-150",
        "focus-visible:ring-2 focus-visible:ring-accent-500/50",
        "disabled:cursor-not-allowed disabled:bg-neutral-50 disabled:text-neutral-400",
        picker && [PICKER_WIDTH[type], "cursor-pointer tabular-nums [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-50 hover:[&::-webkit-calendar-picker-indicator]:opacity-100"],
        className
      )}
      {...props}
    />
    );
  }
);
Input.displayName = "Input";
